import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_217e657c from 'nuxt_plugin_plugin_217e657c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_77e616c1 from 'nuxt_plugin_bootstrapvue_77e616c1' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_vlazyload_7f1b5c00 from 'nuxt_plugin_vlazyload_7f1b5c00' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_axios_72cfea92 from 'nuxt_plugin_axios_72cfea92' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_ff5ff9a4 from 'nuxt_plugin_workbox_ff5ff9a4' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_63423c41 from 'nuxt_plugin_metaplugin_63423c41' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_moment_144e0d74 from 'nuxt_plugin_moment_144e0d74' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_vueveevalidation_0373c73a from 'nuxt_plugin_vueveevalidation_0373c73a' // Source: ../plugins/vue-veevalidation.js (mode: 'all')
import nuxt_plugin_mixinCommonMethods_41494e7d from 'nuxt_plugin_mixinCommonMethods_41494e7d' // Source: ../plugins/mixinCommonMethods.js (mode: 'client')
import nuxt_plugin_datepicker_e866ad72 from 'nuxt_plugin_datepicker_e866ad72' // Source: ../plugins/datepicker.js (mode: 'client')
import nuxt_plugin_vuedynamicstarrating_5704d430 from 'nuxt_plugin_vuedynamicstarrating_5704d430' // Source: ../plugins/vue-dynamic-star-rating.js (mode: 'client')
import nuxt_plugin_googleanalyticsclient_3e5d1144 from 'nuxt_plugin_googleanalyticsclient_3e5d1144' // Source: ../plugins/google-analytics.client.js (mode: 'client')
import nuxt_plugin_googleconversionclient_a159a7d8 from 'nuxt_plugin_googleconversionclient_a159a7d8' // Source: ../plugins/google-conversion.client.js (mode: 'client')
import nuxt_plugin_googleconsentclient_56ee3650 from 'nuxt_plugin_googleconsentclient_56ee3650' // Source: ../plugins/google-consent.client.js (mode: 'client')
import nuxt_plugin_bingclient_623f9112 from 'nuxt_plugin_bingclient_623f9112' // Source: ../plugins/bing.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Check Mot | CheckMot.com | Mot Checker | Check Your Mot Online with CheckMot.com","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1 maximum-scale=1.0, user-scalable=no"},{"hid":"description","name":"description","content":"Check MOT and Tax of UK vehicle, check when your mot is due and the history of your car by using the Check Mot search function. Check MOT online."},{"hid":"fo-verify","name":"fo-verify","content":"fcc7d58c-c07a-48fb-bec0-7409d07c2f05"},{"hid":"og:description","name":"og:description","content":"Check MOT and Tax of UK vehicle, check when your mot is due and the history of your car by using the Check Mot search function. Check MOT online."},{"name":"format-detection","content":"telephone=no"},{"name":"author","content":"CheckMOT"},{"name":"msapplication-TileColor","content":"#4B8EFF"},{"name":"theme-color","content":"#4B8EFF"},{"name":"google-site-verification","content":"EAvdWcviIRNU_Qn63Dy-C8KyuMM9UvVBTxF1pDjDRrk"},{"name":"google-site-verification","content":"XjROzKmGZoFLAI5VReCxVGzUrZtRXQzVPSk6p6d3M2o"},{"name":"msvalidate.01","content":"BAD5C35F1583D38D5FAC462F82536AB8"},{"itemprop":"name","content":""},{"itemprop":"image","content":""},{"property":"og:title","content":"Check Mot | CheckMot.com | Mot Checker | Check Your Mot Online with CheckMot.com"},{"property":"og:type","content":"website"},{"property":"og:url","content":""},{"property":"og:image","content":""},{"name":"msapplication-TileColor","color":"#ffffff"},{"name":"theme-color","color":"#5BBBFF"},{"name":"webgains-site-verification","content":"ilx5hbhg"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Ffavicons\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicons\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicons\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicons\u002Ffavicon-16x16.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicons\u002Fsite.webmanifest"},{"rel":"mask-icon","color":"#5bbad5","href":"\u002Ffavicons\u002Fsafari-pinned-tab.svg"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap"}],"script":[{"src":"https:\u002F\u002Fpagead2.googlesyndication.com\u002Fpagead\u002Fjs\u002Fadsbygoogle.js?client=ca-pub-5474831053767172","body":false,"async":true,"crossorigin":"anonymous"},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=AW-632187223","body":false,"async":true},{"src":"https:\u002F\u002Fpagead2.googlesyndication.com\u002Fpagead\u002Fjs\u002Fadsbygoogle.js","data-ad-client":"ca-pub-5474831053767172","async":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_217e657c === 'function') {
    await nuxt_plugin_plugin_217e657c(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_77e616c1 === 'function') {
    await nuxt_plugin_bootstrapvue_77e616c1(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_7f1b5c00 === 'function') {
    await nuxt_plugin_vlazyload_7f1b5c00(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_72cfea92 === 'function') {
    await nuxt_plugin_axios_72cfea92(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_ff5ff9a4 === 'function') {
    await nuxt_plugin_workbox_ff5ff9a4(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_63423c41 === 'function') {
    await nuxt_plugin_metaplugin_63423c41(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_144e0d74 === 'function') {
    await nuxt_plugin_moment_144e0d74(app.context, inject)
  }

  if (typeof nuxt_plugin_vueveevalidation_0373c73a === 'function') {
    await nuxt_plugin_vueveevalidation_0373c73a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mixinCommonMethods_41494e7d === 'function') {
    await nuxt_plugin_mixinCommonMethods_41494e7d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datepicker_e866ad72 === 'function') {
    await nuxt_plugin_datepicker_e866ad72(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuedynamicstarrating_5704d430 === 'function') {
    await nuxt_plugin_vuedynamicstarrating_5704d430(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalyticsclient_3e5d1144 === 'function') {
    await nuxt_plugin_googleanalyticsclient_3e5d1144(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleconversionclient_a159a7d8 === 'function') {
    await nuxt_plugin_googleconversionclient_a159a7d8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleconsentclient_56ee3650 === 'function') {
    await nuxt_plugin_googleconsentclient_56ee3650(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bingclient_623f9112 === 'function') {
    await nuxt_plugin_bingclient_623f9112(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
